import ScheduleButton from './primary-button'
export default ScheduleButton
